import { render, staticRenderFns } from "./mg-dialog.vue?vue&type=template&id=349ca46b&scoped=true&"
import script from "./mg-dialog.vue?vue&type=script&lang=js&"
export * from "./mg-dialog.vue?vue&type=script&lang=js&"
import style0 from "./mg-dialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./mg-dialog.vue?vue&type=style&index=1&id=349ca46b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349ca46b",
  null
  
)

export default component.exports